"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
CardService.$inject = ['extApi'];
function CardService(extApi) {
    var service = {};
    service.getFinanceSum = function (type) {
        var parsedType = type == 0 ? 'owe' : 'claim';
        return extApi.get('/account/financial', { type: parsedType });
    };
    service.getFinanceDetails = function (type) {
        var parsedType = type == 0 ? 'owe' : 'claim';
        return extApi.get('/account/financial/details', { type: parsedType });
    };
    return service;
}
exports.CardService = CardService;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/card/services/card.js
// module id = 460
// module chunks = 0